module.exports = "<adf-viewer\n  [showToolbar]=\"true\"\n  [showViewer]=\"true\"\n  [overlayMode]=\"true\"\n  [fileNodeId]=\"nodeId\"\n  [allowPrint] = \"true\">\n</adf-viewer>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/caixa/view-documento-eletronico/view-documento-eletronico.component.html
// module id = ../../../../../src/app/components/caixa/view-documento-eletronico/view-documento-eletronico.component.html
// module chunks = main